export default "/static/build/chetty-button-bg.png";